module.exports = __webpack_public_path__ + "img/loading.612e116c.gif";